import React from 'react';

export const redirect = (store, nextState, replace, callback) => {
  replace('/settings/billing');
  callback();
};

function SubscriptionsPageContainer() {
  return <div />;
}

export default SubscriptionsPageContainer;
